var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { gradingApiRequest } from "./client";
import {
  useMutation,
  useQuery,
  useQueryClient
} from "react-query";
const fetchEnrollmentGradebook = (studentId, enrollmentId) => {
  return gradingApiRequest({
    url: `/grade-book/student/${studentId}/enrollment/${enrollmentId}`,
    method: "GET"
  }).then((response) => {
    return response;
  }).catch(() => {
    console.warn("Enrollment Grade book not found");
    return { progress: { actualProgress: 0 } };
  });
};
const fetchAttemptCommentsGradebook = (attemptId) => {
  return gradingApiRequest({
    url: `/grade-book/comment/attempt/${attemptId}`,
    method: "GET"
  });
};
const fetchEnrollmentCommentsGradebook = (enrollmentId) => {
  return gradingApiRequest({
    url: `/grade-book/comment/enrollment/${enrollmentId}`,
    method: "GET"
  });
};
function patchAttemptComment(attemptComment) {
  return gradingApiRequest({
    url: `/grade-book/comment/${attemptComment.commentId}`,
    method: "PATCH",
    data: attemptComment
  }).catch((error) => {
    if ((error == null ? void 0 : error.status) == 403) {
      console.info("PATCH comment action not allowed.", error == null ? void 0 : error.message);
      return attemptComment;
    }
    throw error;
  });
}
const useEnrollmentGradebookQuery = (studentId, enrollmentId, options) => {
  const queryClient = useQueryClient();
  return useQuery(
    ["enrollmentGradebook", enrollmentId],
    () => fetchEnrollmentGradebook(studentId, enrollmentId),
    __spreadProps(__spreadValues({}, options), {
      enabled: !!studentId && !!enrollmentId,
      onSuccess(gradebook) {
        queryClient.setQueryData(
          ["enrollmentGradebook"],
          gradebook == null ? void 0 : gradebook.enrollmentId
        );
      }
    })
  );
};
const useAttemptCommentsQuery = (attemptId, options) => {
  return useQuery(
    ["attemptCommentId", attemptId],
    () => fetchAttemptCommentsGradebook(attemptId),
    __spreadProps(__spreadValues({}, options), {
      enabled: !!attemptId
    })
  );
};
const useEnrollmentCommentsQuery = (enrollmentId, options) => {
  return useQuery(
    ["enrollmentId", enrollmentId],
    () => fetchEnrollmentCommentsGradebook(enrollmentId),
    __spreadProps(__spreadValues({}, options), {
      enabled: !!enrollmentId
    })
  );
};
function useAttemptCommentPatchMutation() {
  return useMutation(
    "patchAttemptComment",
    (attemptComment) => patchAttemptComment(attemptComment),
    { useErrorBoundary: false }
  );
}
export {
  patchAttemptComment,
  useAttemptCommentPatchMutation,
  useAttemptCommentsQuery,
  useEnrollmentCommentsQuery,
  useEnrollmentGradebookQuery
};
